import { render, staticRenderFns } from "./SystemRequirement.vue?vue&type=template&id=31bd1cfa"
import script from "./SystemRequirement.vue?vue&type=script&lang=js"
export * from "./SystemRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bd1cfa')) {
      api.createRecord('31bd1cfa', component.options)
    } else {
      api.reload('31bd1cfa', component.options)
    }
    module.hot.accept("./SystemRequirement.vue?vue&type=template&id=31bd1cfa", function () {
      api.rerender('31bd1cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/SystemRequirement.vue"
export default component.exports